module.exports = __webpack_public_path__ + "static/media/sidenSymbol.6fa99195.svg";